import React from 'react';
import ArrowBackRounded from '@material-ui/icons/ArrowBackRounded';
import ButtonBase from '@material-ui/core/ButtonBase';

import Component from '../../../../../ui-components/Component';
import { withResizer,withUser } from '../../../../../HoCs';
import IconButton from '../../../../../ui-components/Button/Icon';
import styles from './styles';
import ManualForm from '../ManualForm';
import { createProperty, fetchPropertyDetails } from './interactor';
import { handleNetworkError } from '../../../../../ui-components/utils';
import LoaderDialog from '../LoaderDialog';
import { Link } from 'react-router-dom';
import {path} from '../../../../../utils';

class ManualFlow extends Component {

    state = {
        loading: false,
        loaderDialog: false,
        dialogMode: 'loading',
        propertyID: this.props.id,
    };

    styles = styles;
    formRef = React.createRef();

    componentDidMount = () => this.state.propertyID && this.fetchProperty();

    render = () => {
        const { onBack, className, loadingText, successText, actionText,backRoute,finalPageRedirection } = this.props;
        return <div style={this.gs('container')} className={className}>
            <div style={this.gs('header')}>
                <Link to={backRoute}>
                    <IconButton><ArrowBackRounded /></IconButton>
                </Link>
                <div style={this.gs('title')}>{this.props.gc(path(this.props,'title','add_a_property'))}</div>
                <ButtonBase style={this.gs('submit')} onClick={this.submitProperty}>Submit</ButtonBase>
            </div>
            <div style={this.gs('content')}>
                <div style={this.gs('form')}>
                    <Link to={backRoute} style={this.gs('back_icon_wrapper')}>
                        <ArrowBackRounded style={this.gs('back_icon')} />
                    </Link>
                    <ManualForm ref={this.formRef} data={this.state.propertyDetails} gc={this.props.gc}/>
                    <ButtonBase style={this.gs('bottom_submit')} onClick={this.submitProperty}>Submit</ButtonBase>
                </div>
            </div>
            <LoaderDialog open={this.state.loading} mode='loading' loadingText='fetching_property_details'  />
            <LoaderDialog open={this.state.loaderDialog} mode={this.state.dialogMode} loadingText={loadingText}
                          successText={successText} actionText={actionText}
                          actionRoute={this.onDialogActionRoute()}
            />
        </div>;
    };

    fetchProperty = () => this.setState({ loading: true }, () => fetchPropertyDetails(this.state.propertyID,
        propertyDetails => this.setState({ propertyDetails, loading: false }),
        error => this.setState({ loading: false }, () => handleNetworkError(error))
    ));

    submitProperty = () => {
        let data = this.formRef.current.getAnswers(true); if (data === false) return;
        if (this.state.propertyID) data = { ...data, property_unique_id: this.state.propertyID };
        this.setState({ loaderDialog: true, dialogMode: 'loading' }, () => createProperty(data,
            propertyID => this.setState({ loaderDialog: true, dialogMode: 'success', propertyID }),
            error => this.setState({ loaderDialog: false, dialogMode: 'loading' }, () => handleNetworkError(error))
        ));
    };
    
    
    onDialogActionRoute = () => this.props.finalPageRedirection

}

ManualFlow.defaultProps = {
    loadingText: 'authenticating_info',
    successText: 'property_added_successfully',
    actionText: 'view_property_details',
};

export default withUser(withResizer(ManualFlow));